module.exports = __webpack_public_path__ + "img/SeasonOfPride2021_Banner.3dd89d5c.jpg";